import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

import { storage } from '../../libs';

export interface GuestModel {
  preferredCityId?: number;
  language?: string;
}

export type GuestState = {
  guest: GuestModel | null;
};

const initState: GuestState = {
  guest: storage.guest.get() ?? null,
};

export const useGuest = createStore({
  name: 'guest-state',
  devtools: true,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setGuest: handler('guest', u => storage.guest.set(u)),
  };
});
